import { Text, View } from '@react-pdf/renderer';

import { styles } from '../style';

/** Mirrors the on-screen Cash Offer clause word for word. */
const CashOffer = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Cash Offer</Text>

      <Text style={styles.text}>
        1. Buyer may elect to make this Agreement contingent upon obtaining
        mortgage financing. Regardless of any contingency in this Agreement, if
        Buyer chooses to obtain mortgage financing, the following terms apply:
      </Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          a. Buyer will be in default of this Agreement if Buyer furnishes false
          information to anyone concerning Buyer’s financial and/or employment
          status, fails to cooperate in good faith with processing the mortgage
          loan application (including payment for and ordering of appraisal
          without delay), fails to lock in interest rate(s) as stated below, or
          otherwise causes the lender to reject, or refuse to approve or issue,
          a mortgage loan.
        </Text>

        <Text style={styles.listItem}>
          b. <Text style={styles.ClauseText}>Within 7 days</Text> from the
          Execution Date of this Agreement, Buyer will make a completed mortgage
          application (including payment for and ordering of credit reports
          without delay) for the mortgage terms and to the mortgage lender(s),
          if any, otherwise to a responsible mortgage lender(s) of Buyer’s
          choice. Broker for Buyer, if any, otherwise Broker for Seller, is
          authorized to communicate with the mortgage lender(s) to assist in the
          mortgage loan process. Broker for Seller, if any, is permitted to
          contact the mortgage lender(s) at any time to determine the status of
          the mortgage loan application.
        </Text>

        <Text style={styles.listItem}>
          c. Seller will provide access to insurers’ representatives and, as may
          be required by the mortgage lender(s), to surveyors, municipal
          officials, appraisers, and inspectors.
        </Text>

        <Text style={styles.listItem}>
          d. If the mortgage lender(s) gives Buyer the right to lock in interest
          rate(s) at or below the maximum levels desired, Buyer will do so at
          least{' '}
          <Text style={styles.ClauseText}>10 days before Settlement Date</Text>.
        </Text>

        <Text style={styles.listItem}>
          e. If the mortgage lender(s), or a property and casualty insurer
          providing insurance required by the mortgage lender(s), requires
          repairs to the Property, Buyer will, upon receiving the requirements,
          deliver a copy of the requirements to Seller. Within{' '}
          <Text style={styles.ClauseText}>7 days</Text> of receiving the copy of
          the requirements, Seller will notify Buyer whether Seller will make
          the required repairs at Seller’s expense.
        </Text>

        <View style={styles.subList}>
          <Text style={styles.listItem}>
            i. If Seller makes the required repairs to the satisfaction of the
            mortgage lender and/or insurer, Buyer accepts the Property and
            agrees to the Release clause in this Agreement.
          </Text>
          <Text style={styles.listItem}>
            ii. If Seller will not make the required repairs, or if Seller fails
            to respond within the stated time, Buyer will, within 7 Days, notify
            Seller of Buyer’s choice to:
          </Text>
          <View style={styles.subList}>
            <Text style={styles.listItem}>
              A. Make the repairs/improvements at Buyer’s expense, with
              permission and access to the Property given by Seller, which will
              not be unreasonably withheld (Seller may require that Buyer sign a
              pre-settlement possession agreement such as the Pre-Settlement
              Possession Addendum, which shall not, in and of itself, be
              considered unreasonable), OR
            </Text>
            <Text style={styles.listItem}>
              B. Terminate this Agreement by written notice to Seller, with all
              deposit monies returned to Buyer according to this Agreement.
            </Text>
            <Text style={styles.listItem}>
              C. If Buyer fails to respond within the time stated above or fails
              to terminate this Agreement by written notice to Seller within
              that time, Buyer will accept the Property, make the required
              repairs/improvements at Buyer’s expense and agree to the Release
              clause of this Agreement.
            </Text>
          </View>
          <Text style={styles.listItem}>
            iii. The Loan-To-Value ratio (LTV) is used by lenders as one tool to
            help assess their potential risk of a mortgage loan. A particular
            LTV may be necessary to qualify for certain loans, or buyers might
            be required to pay additional fees if the LTV exceeds a specific
            level. The appraised value of the Property may be used by lenders to
            determine the maximum amount of a mortgage loan. The appraised value
            is determined by an independent appraiser, subject to the mortgage
            lender’s underwriter review, and may be higher or equal to the
            Purchase Price and/or market price of the Property.
          </Text>
        </View>

        <Text style={styles.listItem}>
          f. <Text style={styles.bold}>Mortgage Contingency:</Text> This sale is
          NOT contingent on mortgage financing, although Buyer may obtain
          mortgage financing and/or the parties may include an appraisal
          contingency. Buyer and Seller understand that the waiver of this
          contingency does not restrict Buyer’s right to obtain mortgage
          financing for the Property.
        </Text>
      </View>
    </View>
  );
};

export default CashOffer;
